import React, { Component } from 'react';
import { ResponsiveContainer, BarChart, Bar, CartesianGrid, XAxis, YAxis, Tooltip } from 'recharts';

import utils from '../util/utils';

function textWidth(str) {
    return 25 + 7 * (str.length || 0);
}

const HistogramTooltip = (props) => {
    if (props.active && props.payload?.length) {
        const value = props.payload[0].value;
        if (!props.label && !value) return null;

        return (
            <div className="tooltip-clone">
                <div>{props.label}</div>
                <div>{props.percent ? utils.toFixed(value, 4) + '%' : value.toLocaleString()}</div>
            </div>
        );
    }

    return null;
};

export const HistogramLabel = (props) => {
    const label = props.percent ? utils.toFixed(props.value, 1) + '%' : props.value.toLocaleString();
    const anchor = props.x + props.width;
    const width = document.getElementById('statistics')?.offsetWidth || window.innerWidth;

    if (anchor + textWidth(label) > width) {
        // text inside the bar
        return <text x={anchor - 5} y={props.y + props.height/2} dy="5" fill="#f0ebe0" textAnchor="end">{label}</text>;
    } else {
        return <text x={anchor + 5} y={props.y + props.height/2} dy="5" fill="#f0ebe0" textAnchor="start">{label}</text>;
    }
};

export default class Histogram extends Component {
    render() {
        if (!this.props.data?.length) return null;

        const sum = this.props.data.reduce((partialSum, elem) => partialSum + elem.count, 0);
        const data = this.props.data.map(elem => ({ percent: 100.0 * (elem.count || 0) / (sum || 1), ...elem }));
        const width = Math.max(...this.props.data.map(elem => textWidth(elem.bucket)));

        const Axis1 = this.props.horizontal ? YAxis : XAxis;
        const Axis2 = this.props.horizontal ? XAxis : YAxis;
        const CustomTooltip = this.props.tooltip;
        const CustomLabel = this.props.label;

        return (
            <ResponsiveContainer width="100%" height="100%">
                <BarChart data={data} margin={{ top: 0, right: 0, bottom: 0, left: 0 }} layout={this.props.horizontal ? 'horizontal' : 'vertical'}>
                    <CartesianGrid stroke="#292d32" horizontal={this.props.horizontal} />
                    <Bar dataKey={this.props.percent ? 'percent' : 'count'} fill="#375a7f" stroke={window.bootstrap.md.matches ? '#292d32' : '#375a7f'} isAnimationActive={false} label={this.props.label ? <CustomLabel data={data} percent={this.props.percent} /> : <HistogramLabel percent={this.props.percent} />} />
                    <Axis1 stroke="#f0ebe0" type="number" width={70} dataKey={this.props.percent ? 'percent' : 'count'} tickCount={10} tickFormatter={v => this.props.percent ? utils.toFixed(v, 1) + '%' : v.toLocaleString()} />
                    <Axis2 stroke="#f0ebe0" type="category" dataKey="bucket" width={Math.min(110, width)} interval={this.props.interval || 0} tickLine={false} />
                    <Tooltip content={this.props.tooltip ? <CustomTooltip data={data} /> : <HistogramTooltip percent={this.props.percent} />} cursor={false} />
                </BarChart>
            </ResponsiveContainer>
        );
    }
}